import React, { useState, useEffect } from "react";
import axios from "axios";
import SectionLandingLikePublications from "../common/SectionLandingLikePublications";

export default function MarketConduct() {
  const [post, setPost] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get("/marketconduct")
      .then((response) => {
        const data = response.data;
        if (!cancelled) {
          setPost(Array.isArray(data) ? data : data ? [data] : []);
        }
      })
      .catch(() => {
        if (!cancelled) setPost([]);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const lead = (
    <>
      <p>
        The National Bank of Rwanda adopted a mandate of market conduct supervision to foster a conducive
        environment for consumer empowerment and to promote transparency and integrity within the financial
        sector.
      </p>
      <p>Explore the topics and resources in this section below.</p>
    </>
  );

  return (
    <SectionLandingLikePublications
      breadcrumbCurrent="Market Conduct"
      headingId="market-conduct-bnr-heading"
      pageTitle="Market Conduct"
      tagline="Supervision, transparency and consumer protection"
      sharePageTitle="Market Conduct — National Bank of Rwanda"
      lead={lead}
      posts={post}
      pageFeedbackPath="/marketconduct"
      isLoading={isLoading}
    />
  );
}
